import Router from 'next/router';
import moment from 'moment';
import { OnInit } from '@model/bootstrap/on-init';
import Cookies, { Cookie } from '@model/common/cookie/cookie';

export class Epc implements OnInit {
  epc: string = '';
  initialize(): void {
    if (!this.epc) {
      const queryMatch = /[\?&]epc=(\w+)/.exec(Router.asPath);
      const queryEpc = queryMatch && queryMatch[1];
      const cookies = new Cookies();
      const existingEpc = cookies.get(Cookie.EPC);

      if (queryEpc && existingEpc !== queryEpc) {
        cookies.set({
          id: Cookie.EPC,
          value: `${queryEpc}`,
          options: {
            path: '/',
            expires: moment().add(2, 'weeks').toDate(),
            sameSite: 'strict',
            secure: true
          }
        });
        cookies.set({
          id: Cookie.CANCEL_PROMO,
          value: 'true',
          options: {
            path: '/',
            expires: moment().add(2, 'weeks').toDate(),
            sameSite: 'strict',
            secure: true
          }
        });
      }
    }
  }
}
